import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_8.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionIntegrityManagement extends Component {

    render() {
        return (
            <>
                <Header1 />

                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Integrity Management</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Integrity Management</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2">
                            <div className="container about-video">

                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={8} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Integrity Management</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>
                                            We provide complete integrity management programs covering inspection, 
                                            diagnostics, risk assessment, and performance monitoring for industrial 
                                            assets and oil & gas facilities.
                                        </p>

                                        <div className="row m-b30">
                                            <div className="col-md-12">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>
                                            GO-PS ensures the structural reliability of assets to prevent failures, 
                                            reduce downtime, and extend operational life cycles.
                                        </p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Static & rotating equipment inspection</li>
                                                    <li>Pipeline integrity evaluation</li>
                                                    <li>Non-destructive testing (NDT)</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Corrosion monitoring</li>
                                                    <li>Failure analysis & diagnostics</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Benefits</h4>
                                        <p>Reliable asset performance, reduced operational risks, and improved safety.</p>

                                        <div className="row">

                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Extended asset lifetime</li>
                                                    <li><i className="flaticon-light-bolt"></i>Compliance with industry standards</li>
                                                    <li><i className="flaticon-mask"></i>Continuous monitoring</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">NDT Services</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Complete non-destructive testing including UT, PT, MT, RT and visual inspection.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Corrosion Control</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Monitoring and mitigation techniques to ensure safe operation of equipment.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        </Accordion>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <Footer1 />

            </>
        );
    }
}

export default SolutionIntegrityManagement;
